import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

/**
 * Link tipo breadcrumb para volver a la pantalla que llamó a esta (detalle,
 * edición, alta). Se ubica debajo de TituloPagina.
 *
 * Props:
 *   to    — ruta a la que vuelve (navegación explícita, no navigate(-1))
 *   label — texto de la pantalla de origen, ej: "Registros de productos"
 *
 * Ejemplo:
 *   <VolverBreadcrumb to="/productos" label="Productos" />
 */
function VolverBreadcrumb({ to, label }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ mb: 2 }}>
      <Link
        component="button"
        variant="body2"
        onClick={() => navigate(to)}
        sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
        underline="hover"
      >
        <ArrowBackIcon sx={{ fontSize: '1rem' }} />
        <Typography variant="body2" component="span">Volver a {label}</Typography>
      </Link>
    </Box>
  );
}

export default VolverBreadcrumb;
